import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";
import {AuthService} from "../services/auth.service";
import {ModalsService} from "../services/modals.service";

export const authGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const modalsService = inject(ModalsService);
  const currentUrl = state.url;

  if (authService.authenticated) {
    return true;
  }

  modalsService.showLogin(() => router.navigate([currentUrl]));
  return router.parseUrl('/');
};
